import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Card, Table, Modal, Label, Form } from "reactstrap";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
// assets
import Loader from "pages/Separate/Loader";
import NewPagination from "components/Common/Newpagination";
import AccessDeniedPopup from "routes/AccessDeniedPopup";
import leaveImg2 from "../../../assets/images/LeaveDetails.jpg";
import { fetchNodeData } from "utils/common-fetchData";
import Swal from "sweetalert2";
import { customGlobalFilter } from "utils/common-helpers";
import moment from "moment";
import { pendingLeaveColumns } from "utils/columns/ElementsColumns/leaveColumns";

function TableContainer({ columns, data, members, toggleLoading }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { pageIndex, pageSize, globalFilter } = state;
  const [devCounts, setDevCounts] = useState(5);
  const [nonTechCounts, setNonTechCounts] = useState(11);

  useEffect(() => {
    setPageSize(10);
  }, []);
  // Render the UI for your table

  return (
    <div>
      <Row>
        <Col xl="12">
          <div className="card-body ">
            <div className="d-flex mb-2 align-items-start flex-wrap gap-3">
              <div className="mb-3 text-purple fs-5 fw-bold">
                Pending Leaves
              </div>

              <div className="d-flex gap-3 align-items-center">
                <div className="d-flex gap-2 align-items-center general-box px-3 rounded">
                  <h6 className="text-purple mb-0">
                    Yesha Makwana :{" "}
                    <span className="text-primary ml-2">
                      {
                        data?.filter(
                          (obj) =>
                            obj?.roleid != 5 &&
                            obj?.roleid != 15 &&
                            obj?.roleid != 20 &&
                            obj?.roleid != 21 &&
                            obj?.roleid != 23 &&
                            obj?.roleid != 24
                        )?.length
                      }
                    </span>
                  </h6>
                </div>
                <div className="d-flex gap-2 align-items-center general-box px-3 rounded">
                  <h6 className="text-purple mb-0">
                    Mohit Kapadnis :
                    <span className="text-primary ml-2">
                      {
                        data?.filter(
                          (obj) =>
                            obj?.roleid == 5 ||
                            obj?.roleid == 15 ||
                            obj?.roleid == 20 ||
                            obj?.roleid == 21 ||
                            obj?.roleid == 23 ||
                            obj?.roleid == 24
                        )?.length
                      }
                    </span>
                  </h6>
                </div>
                <div className="d-flex gap-2 align-items-center general-box px-3 rounded bg-purple">
                  <h6 className="text-white mb-0">
                    Total Leaves :{" "}
                    <span className="text-white ml-2">{data?.length}</span>
                  </h6>
                </div>
              </div>
            </div>

            <Row className="mb-2 justify-content-between">
              <div className="mb-3 mb-md-0 d-flex justify-space-between align-items-center">
                <div className="col-1 me-md-5">
                  <select
                    className="border-radius form-select"
                    style={{ width: "100px" }}
                    value={pageSize}
                    onChange={(e) => setPageSize(e.target.value)}
                  >
                    {[10, 25, 50, 100].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        Show {pageSize}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-10 d-flex justify-content-end align-items-center">
                  <div className="col-4 cusrtom_search_box">
                    <div className="search-box me-xxl-2 my-xxl-0 d-inline-block w-100">
                      <div className="">
                        <div className="position-relative">
                          <label
                            htmlFor="search-bar-0"
                            className="search-label w-100 mb-0"
                          >
                            <span id="search-bar-0-label" className="sr-only">
                              Search this table
                            </span>
                            <input
                              onChange={(e) => setGlobalFilter(e.target.value)}
                              id="search-bar-0"
                              type="text"
                              className="border-radius form-control rounded h-100 w-100"
                              placeholder={`Search...`}
                              value={globalFilter || ""}
                            />
                          </label>
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Row>
            <div className="position-relative table-responsive">
              <Table className="table table-bordered mt-4" {...getTableProps()}>
                <thead className={`fixed_view_payment_table`}>
                  {headerGroups.map((headerGroup, i) => (
                    <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th
                          key={index}
                          className={`t-col-${index + 1} ${column.className}`}
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          <div className="d-flex align-items-center">
                            <span className="flex-grow-1  header-text">
                              {column.render("Header")}
                            </span>
                            {column.isShortIcon && (
                              <span
                                onClick={() =>
                                  column.getSortByToggleProps().onClick()
                                }
                                className="d-flex align-items-center ms-2"
                              >
                                <i
                                  title="Ascending"
                                  className={`bi bi-arrow-up info-icon ${
                                    column.isSorted && !column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                                <i
                                  title="Descending"
                                  className={`bi bi-arrow-down info-icon ${
                                    column.isSorted && column.isSortedDesc
                                      ? "text-dark"
                                      : ""
                                  }`}
                                ></i>
                              </span>
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody
                  className="fix-introducer-header"
                  {...getTableBodyProps()}
                >
                  {page.map((row, i) => {
                    prepareRow(row);
                    // const rowBackgroundColor =
                    //   row?.original?.leave_type == 2
                    //     ? "bg-light-red2"
                    //     : "bg-light-blue2";

                    return (
                      <tr
                        // className={`row-hover ${rowBackgroundColor}`}
                        className="row-hover"
                        {...row.getRowProps()}
                        key={i}
                      >
                        {row.cells.map((cell, index) => {
                          return (
                            <td
                              key={index}
                              className={`t-col-${index + 1} ${
                                cell.column.className
                              }`}
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>

            <Row className="justify-content-md-end justify-content-center align-items-center">
              <NewPagination
                gotoPage={gotoPage}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                canNextPage={canNextPage}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                pageSize={pageSize}
                page={page}
                data={data}
                nextPage={nextPage}
              />
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
}

const PendingLeaves = () => {
  const [isLoading, setLoading] = useState(false);
  const [modal_Access, setAccessDenied] = useState(false);
  const [data, setData] = useState([]);
  const toggleLoading = (loading) => {
    setLoading(loading);
  };

  const column1 = useMemo(() => pendingLeaveColumns(), []);
  useEffect(() => {
    const fetchLeaves = async () => {
      const res = await fetchNodeData(toggleLoading, `approvalList/${1}`, "");
      if (res?.success) {
        setData(res?.data);
      }
    };
    fetchLeaves();
  }, []);

  return (
    <div>
      <React.Fragment>
        {isLoading && <Loader />}
        <div className="">
          <div className="position-relative">
            <Row>
              <Col lg="12">
                <Card>
                  <div className="responsive-table">
                    <TableContainer
                      data={data}
                      toggleLoading={toggleLoading}
                      columns={column1}
                    />
                  </div>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <AccessDeniedPopup
          modal_Access={modal_Access}
          setAccessDenied={setAccessDenied}
        />
      </React.Fragment>
    </div>
  );
};

export default PendingLeaves;
